import * as S from './styles';

function TabPagamento() {
  return (
    <div>
      <S.Section>
        <S.Title>Metodos de pagamento</S.Title>
        <S.Subtitle>Atualize seus meios de pagamento e enderessos</S.Subtitle>
      </S.Section>
    </div>
  );
}

export default TabPagamento;